import { TAppState } from '../../types/appState';

export function chatCustomActionModalSelector(state: TAppState) {
  return state.chatCustomActionModal;
}
